import { useState } from 'react';
import { apiClient, buildAuthRequestConfig } from '../utils/apiClient';

const usePut = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const putData = async (url, payload) => {
        setLoading(true);
        setError(null);
        try {
            const response = await apiClient.put(url, payload, buildAuthRequestConfig());
            setData(response.data);
            setLoading(false);
            return response.data;
        } catch (error) {
            setError(error);
            setLoading(false);
            throw error;
        }
    };

    return { data, loading, error, putData };
};

export default usePut;
